import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import ParticipantForm from "../components/AddParticipant/ParticpantForm";

const EditHousehold = () => {
    useEffect(() => {
        document.title = "Edit Household";
    }, []);

    const { id } = useParams();

    return (
        <div className="row justify-content-center">
            <div className="column-medium-10">
                <ParticipantForm id={id} mode="household" />
            </div>
        </div>
    );
};

export default EditHousehold;
